import {Location} from '@angular/common';

export const APP_URL = location.protocol + '//' + location.host;
